<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingBerekening">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBerekening" aria-expanded="false" aria-controls="collapseBerekening">
                Berekening van de schenkbelasting
            </button>
        </h2>
        <div id="collapseBerekening" class="accordion-collapse collapse" aria-labelledby="headingBerekening"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De schenkbelasting wordt berekend op basis van de waarde van de schenking, verminderd met eventuele
                vrijstellingen. Het belastbare bedrag wordt vervolgens belast tegen een tarief dat afhankelijk is van de
                relatie tussen schenker en ontvanger.

                <div class="space20"></div>

                <b>1. Vaststellen waarde schenking</b><br/>
                De waarde van het geschonken bedrag of goed wordt bepaald op het moment van schenking. Voor goederen
                geldt de marktwaarde.

                <div class="space20"></div>

                <b>2. Toepassen van vrijstellingen</b><br/>
                Trek de toepasselijke vrijstelling (bijvoorbeeld voor kinderen of derden) af van de waarde. Alleen het
                resterende bedrag is belastbaar.

                <div class="space20"></div>

                <b>3. Toepassen van het tarief</b><br/>
                De Belastingdienst hanteert tariefgroepen:
                <ul>
                    <li><b>Kinderen en kleinkinderen:</b> 10% tot € 152.368, daarna 20%</li>
                    <li><b>Overige personen (bijv. neven, vrienden):</b> 30% tot € 152.368, daarna 40%</li>
                </ul>
                De tarieven worden toegepast op het belastbare deel van de schenking (dus: waarde minus vrijstelling).

                <div class="space20"></div>

                <b>4. Eventueel schenkbelasting "vrij van recht"</b><br/>
                Als de schenker de belasting voor zijn rekening neemt (schenking vrij van recht), verhoogt de
                Belastingdienst de schenking met het bruto bedrag van de schenkbelasting. Dit leidt tot een hogere
                belastinggrondslag.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingBetalen">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseBetalen" aria-expanded="false" aria-controls="collapseBetalen">
                Hoe, wie en wanneer aanslag betalen
            </button>
        </h2>
        <div id="collapseBetalen" class="accordion-collapse collapse" aria-labelledby="headingBetalen"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De ontvanger is verplicht om aangifte te doen en betaalt meestal ook de schenkbelasting. Maar de
                schenker kan er ook voor kiezen om de schenkbelasting te betalen. In het aangifteformulier vul je in wie
                de schenkbelasting betaalt. Wie de schenkbelasting ook betaalt, de aanslag staat altijd op naam van de
                ontvanger en deze krijgt de aanslag dan ook thuis gestuurd.
                <div class="space20"></div>
                De Belastingdienst berekent na het ontvangen van de aangifte de verschuldigde belasting en legt een
                aanslag Schenkbelasting op. Op de aanslag staan de betalingsgegevens (termijn, aanslagnummer, rekeningnummer).
                <div class="space20"></div>
                Betaalt de schenker de schenkbelasting? Als ontvanger blijf je wel aansprakelijk voor het betalen van de
                schenkbelasting. Let er dus op dat het bedrag van de aanslag op tijd bij ons binnen is.
                <div class="space20"></div>
                <b>Let op!</b> Alleen de ontvanger kan bezwaar maken tegen de aanslag schenkbelasting.
            </div>
        </div>
    </div>
</div>
